import { render, staticRenderFns } from "./DunningLevelCard.vue?vue&type=template&id=2a8c8b5c&"
import script from "./DunningLevelCard.vue?vue&type=script&lang=js&"
export * from "./DunningLevelCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports